<div #tableWrapper class="table-wrapper">
<ngx-datatable
  class="bootstrap"
  [rows]="rows"
  [rowHeight]="40"
  [sortType]="'multi'"
  [headerHeight]="50"
  [footerHeight]="50"
  [columnMode]="'force'"
  [scrollbarH]="false"
  [externalPaging]="true"
  [count]="totalElements"
  [offset]="pageNumber - 1"
  [limit]="pageSize"
  (page)="changePage($event)"
  [externalSorting]="true" 
    (sort)="onSort($event)"
    [sortType]="'single'"
    >
    
     <ngx-datatable-column
      name="Cust Code"
      prop="customerCode"
      [width]="90"
      [minWidth]="90">
      <ng-template ngx-datatable-cell-template let-value="value">
        <a (click)="routeCustomer(value)" class="link">{{ value }}</a>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      name="Dept Code / Name"
      prop="departmentCode"
      [width]="280"
      [minWidth]="280">
      <ng-template ngx-datatable-cell-template let-row="row">
        <a (click)="routeDepartment(row)" class="link">
           {{ row.departmentCode }} - {{ row.departmentName }}
        </a>
      </ng-template>
    </ngx-datatable-column>

    <!-- Stop column (WO) -->
    <ngx-datatable-column
      *ngIf="pageType !== 'garmentListing'"
      name="Stop Code/Name"
      [width]="280"
       prop="stopCode"
      [minWidth]="280">
      <ng-template ngx-datatable-cell-template let-row="row">
        <a (click)="routeStopWO(row)" class="link">
          {{ row.stopCode }} - {{ row.stopName }}
        </a>
      </ng-template>
    </ngx-datatable-column>

    <!-- Stop column (GL) -->
    <ngx-datatable-column
      *ngIf="pageType === 'garmentListing'"
      name="Stop Code/Name"
       prop="stopCode"
      [width]="280"
      [minWidth]="280">
      <ng-template ngx-datatable-cell-template let-row="row">
        <a (click)="routeStopGL(row)" class="link">
          {{ row.stopCode }} - {{ row.stopName }}
        </a>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      name="Employee"
      prop="employeeCode"
      [width]="90"
      [minWidth]="90">
      <ng-template ngx-datatable-cell-template let-row="row" let-value="value">
        <a (click)="routeEmployee(row)" class="link">{{ value }}</a>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      name="Last Name"
      prop="lastName"
      [width]="100"
      [minWidth]="100">
    </ngx-datatable-column>

    <ngx-datatable-column
      name="First Name"
      prop="firstName"
      [width]="100"
      [minWidth]="100">
      <ng-template ngx-datatable-cell-template let-row="row">
        {{ row.firstName }}
        <span *ngIf="row.deliveryAddress1">
          ({{ row.deliveryAddress1 }})
        </span>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      name="Locker"
      prop="lockerNum"
      [width]="90"
      [minWidth]="90">
    </ngx-datatable-column>
     
 <ngx-datatable-footer>
    <ng-template ngx-datatable-footer-template>

      <div class="dt-footer">
      <div class="dt-left">
       
       
        <span *ngIf="totalElements>0">
          Page {{ pageNumber }} of {{ totalPages }}  (Total: {{totalElements}})
        </span>
         <span *ngIf="totalElements==0">
          Total {{totalElements}}
        </span>
         <span  *ngIf="totalElements>0">Rows per page: </span>
    <select (change)="changePageSize(+$any($event.target).value)"  *ngIf="totalElements>0">
        <option
          *ngFor="let s of [20,40,60,100,200,500]"
          [value]="s"
          [selected]="s === pageSize">
          {{ s }}
        </option>
      </select>


        </div>
         <div class="dt-right"  *ngIf="totalElements>0">
          <button
              (click)="first()"
              [disabled]="pageNumber===1"
              aria-label="First Page">
           <i class="datatable-icon-prev"></i>
            </button>
        <button (click)="prev()"   [class.disabled-btn]="pageNumber===1">
           <i class="datatable-icon-left"></i>
        </button>
     
        <ng-container *ngFor="let p of pages" style="font-size: 13px;">
          <button
            (click)="goToPage(p)"
            [class.active]="p === pageNumber">
          {{ p }}
          </button>
        </ng-container>

        <button (click)="next()"   [class.disabled-btn]="pageNumber>= totalPages">
         <i class="datatable-icon-right"></i>
        </button>
         <button
          (click)="last()"
          [disabled]="pageNumber >= totalPages"
          aria-label="Last Page">
          <i class="datatable-icon-skip"></i>
        </button>

       </div>
    </div>

    </ng-template>
  </ngx-datatable-footer>
  </ngx-datatable>

  </div>